module.exports = {
          srcSet: __webpack_public_path__ + "public/5a6c699720131a325f22ebdd3880f068-80.png"+" 80w",
          images:[ {path: __webpack_public_path__ + "public/5a6c699720131a325f22ebdd3880f068-80.png",width: 80,height: 80}],
          src: __webpack_public_path__ + "public/5a6c699720131a325f22ebdd3880f068-80.png",
          toString:function(){return __webpack_public_path__ + "public/5a6c699720131a325f22ebdd3880f068-80.png"},
          
          width: 80,
          height: 80
        }